<template>
    <RejectedPayments></RejectedPayments>
</template>
<script>
    import RejectedPayments from '@/components/RejectedPaymentLiquidations.vue'
    export default {
        name: 'approved-liquidations',
        components: {
            RejectedPayments
        }
    }
</script>